(function($) {

$(document).ready(function(){
	$('.modal__box__close').on('click',function(){
		$('.modal').fadeOut();
	});
	$('.modal').on('click',function(e){
		if ($(e.target).is('.modal')) {
			$('.modal').fadeOut();
		}
	});
});

})( jQuery );  